import { faQuestion } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function AqeedahFAQs() {
  return (
    <section className="my-10">
      <div className="divider text-4xl text-slate-500 my-20">FAQs</div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-7 lg:mx-32">
        <div className="flex">
          <div className="justify-center">
            <p className="bg-red-100 p-5 rounded">
              <FontAwesomeIcon
                className="text-4xl text-red-600"
                icon={faQuestion}
              />
            </p>
          </div>
          <div className="px-2">
            <p className="text-xl text-red-600">
              কোর্সে কি যে কেউ ভর্তি হতে পারবে?
            </p>
            <p>
              জি, ১৫ বছরের বেশি বয়সী, যে কোন শ্রেণি-পেশার মানুষ যে কেউ এই কোর্সে
              ভর্তি হতে পারবে। যেমন, মাদরাসার শিক্ষক-শিক্ষার্থী, জেনারেল পড়ুয়া
              বা বিশ্ববিদ্যালয়ে অধ্যায়নরত শিক্ষার্থী, চাকুরিজীবি{" "}
            </p>
          </div>
        </div>
        <div className="flex">
          <div className="justify-center">
            <p className="bg-red-100 p-5 rounded">
              <FontAwesomeIcon
                className="text-4xl text-red-600"
                icon={faQuestion}
              />
            </p>
          </div>
          <div className="px-2">
            <p className="text-xl text-red-600">ক্লাস কিভাবে হবে?</p>
            <p>
              টেলিগ্রাম গ্রুপ ও চ্যানেলের মাধ্যমে ক্লাস হবে। বিভিন্ন টপিকের উপর
              অডিও দেওয়া হবে। আপনাদেরকে প্রশ্ন দেওয়া হবে, আপনারা উত্তর টাইপ
              করে/ভয়েজ রেকর্ড করে/খাতায় লিখে ছবি তুলে জমা দিবেন। এছাড়াও MCQ
              পরীক্ষা থাকবে, আপনারা সঠিক উত্তর সিলেক্ট করবেন। (টেলিগ্রাম হচ্ছে
              হোয়াটসঅ্যাপের মতো একটি অ্যাপ, প্লে স্টোর থেকে ডাউনলোড করে নিতে
              পারবেন।)
            </p>
          </div>
        </div>
        <div className="flex">
          <div className="justify-center">
            <p className="bg-red-100 p-5 rounded">
              <FontAwesomeIcon
                className="text-4xl text-red-600"
                icon={faQuestion}
              />
            </p>
          </div>
          <div className="px-2">
            <p className="text-xl text-red-600">কিভাবে পড়া বুঝিয়ে দেওয়া হবে?</p>
            <p>
              বাংলায় পড়ানো হবে। কুরআনের আয়াত ও হাদিসের অর্থ ভেঙে ভেঙে বুঝিয়ে
              দেওয়া হবে। আপনাদেরকে আয়াত ও হাদিস মুখস্থ করানো হবে, তবে পরীক্ষায়
              লেখতে হবেনা।{" "}
            </p>
          </div>
        </div>
        <div className="flex">
          <div className="justify-center">
            <p className="bg-red-100 p-5 rounded">
              <FontAwesomeIcon
                className="text-4xl text-red-600"
                icon={faQuestion}
              />
            </p>
          </div>
          <div className="px-2">
            <p className="text-xl text-red-600">ক্লাস কি লাইভ হবে?</p>
            <p>
              বিশেষ কিছু ক্লাস লাইভ হবে, সবগুলো না। বেশিভাগ ক্লাস রেকর্ডেড হবে,
              তবে ক্লাসের নিদৃষ্ট সময় আছে, এই সময়ে পড়া দেওয়া হবে। ক্লাসের সময়
              উপস্থিত থাকতে পারলে ভালো। তবে অডিও লেকচার দেওয়া হবে, তাই পরেও
              শুনতে পারবেন।{" "}
            </p>
          </div>
        </div>
        <div className="flex">
          <div className="justify-center">
            <p className="bg-red-100 p-5 rounded">
              <FontAwesomeIcon
                className="text-4xl text-red-600"
                icon={faQuestion}
              />
            </p>
          </div>
          <div className="px-2">
            <p className="text-xl text-red-600">ক্লাস মিস হলে কি করব?</p>
            <p>
              ক্লাস মিস হলে কোন সমস্যা নেই। প্রতিটি দারস টেলিগ্রাম চ্যানেলে
              দেওয়া থাকবে। সেখান থেকে শুনে নিলেই হবে। ক্লাস টেস্টও যে কোন সময়
              দিতে পারবেন। তবে, সেমিস্টার পরীক্ষা নির্ধারিত সময়ের মধ্যেই দিতে
              হবে, পরে দেওয়া যাবে না।
            </p>
          </div>
        </div>
        <div className="flex">
          <div className="justify-center">
            <p className="bg-red-100 p-5 rounded">
              <FontAwesomeIcon
                className="text-4xl text-red-600"
                icon={faQuestion}
              />
            </p>
          </div>
          <div className="px-2">
            <p className="text-xl text-red-600">
              অডিওগুলো/দারসগুলো কি আমি কারো সাথে শেয়ার করতে পারব?
            </p>
            <p>
              আপনি ব্যক্তিগতভাবে কাউকে দিতে চাইলে দিতে পারেন। যেমন, আপনার
              পরিবারের কোন সদস্য, বন্ধু, কলিগ ইত্যাদি। তবে কোন গ্রুপে/চ্যানেলে
              শেয়ার করবেন না। তবে, আপনি যা শিখছেন/শিখবেন, সেটার আপনার ভাষায়, সহজ
              ও সুন্দরভাবে মানুষকে বুঝাবেন এবং শিখাবেন।
            </p>
          </div>
        </div>
        <div className="flex">
          <div className="justify-center">
            <p className="bg-red-100 p-5 rounded">
              <FontAwesomeIcon
                className="text-4xl text-red-600"
                icon={faQuestion}
              />
            </p>
          </div>
          <div className="px-2">
            <p className="text-xl text-red-600">কিভাবে পুরষ্কার পাব?</p>
            <p>
              যারা সেমিস্টার পরীক্ষাগুলোতে ভালো রেজাল্ট করবে, তাদের মধ্যে সেরা
              (লেভেল ১ এ ১০ জন, লেভেল ২+৩ এ ৫ জন) -কে পুরষ্কার দেওয়া হবে।{" "}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
